export default __webpack_public_path__ + "static/B0270-ed2960d2001e84c2c0f878b296ab80dc.png";